package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import io.horion.cv.models.CenterInterestState
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.components.cards.GenericFormCard
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.widgets.AddButton
import io.horion.cv.di.koinGet
import org.jetbrains.compose.web.css.px

@Composable
fun CenterInterestAccordionContent(
    onComplete: (String) -> Unit,
    onAddCompetenceAndClose: (String) -> Unit,
) {
    val cvViewModel = koinGet<CvViewModel>()
    val cvUiState = cvViewModel.cvUiState
    val hobbiesFromVM = cvUiState.data.hobbies

    LaunchedEffect(Unit) {
        if (hobbiesFromVM.isEmpty()) {
            cvViewModel.updateHobby(0, "")
            cvViewModel.editingCenterInterestId = "center_interest-0"
        }
    }

    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(30.px)
    ) {
        hobbiesFromVM.forEachIndexed { index, hobbyText ->
            val tempId = "center_interest-$index"

            val state = remember(hobbyText) {
                CenterInterestState(id = tempId, center_interest = hobbyText)
            }

            GenericFormCard(
                item = state,
                isEditing = cvViewModel.editingCenterInterestId == tempId,
                onEdit = { cvViewModel.editingCenterInterestId = tempId },
                onDelete = {
                    cvViewModel.deleteHobby(index)
                    if (cvViewModel.cvUiState.data.hobbies.isEmpty()) {
                        cvViewModel.updateHobby(0, "")
                        cvViewModel.editingCenterInterestId = "center_interest-0"
                    } else {
                        cvViewModel.editingCenterInterestId = null
                    }
                },
                onComplete = { cvViewModel.editingCenterInterestId = null },
                getSummary = { ci ->
                    if (ci.center_interest.isNotBlank()) {
                        SummaryData(title = ci.center_interest, subtitle = "")
                    } else null
                },
                getDefaultText = { "[Centre d'intérêt]" },
                formContent = { s, onDel, onComp ->
                    CenterInterestForm(
                        index = index,
                        state = s,
                        cvViewModel = cvViewModel,
                        onDelete = onDel,
                        onComplete = onComp
                    )
                }
            )
        }

        AddButton(
            text = "Ajouter un centre d'intérêt",
            onClick = {
                val nextIndex = hobbiesFromVM.size
                cvViewModel.updateHobby(nextIndex, "")
                cvViewModel.editingCenterInterestId = "center_interest-$nextIndex"
            }
        )
    }
}